import { render, staticRenderFns } from "./expressSku.vue?vue&type=template&id=3b9dbe58&scoped=true&"
import script from "./expressSku.vue?vue&type=script&lang=js&"
export * from "./expressSku.vue?vue&type=script&lang=js&"
import style0 from "./expressSku.vue?vue&type=style&index=0&id=3b9dbe58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9dbe58",
  null
  
)

export default component.exports